import useCreateAxiosInstance from './useCreateAxiosInstance';
import useKeywordMetadata from './useKeywordMetadata';
import useServiceAppState from './useServiceAppState';

const SERVICE_NAME = 'stream';
const ENDPOINT_KEY = 'kc-bff';

/**
 * Task BFF axios instance.
 * @description
 * - notification과 동일한 `kc-bff` 엔드포인트(stream service meta)를 사용한다.
 * - endpoint가 준비되기 전에는 baseURL이 빈 문자열이므로,
 *   호출 측에서 `Boolean(endpoint)`로 enabled 가드를 걸어야 함.
 */
const useTaskApiInstance = () => {
  const {
    state: { region },
  } = useServiceAppState();
  const { data: metadata } = useKeywordMetadata(SERVICE_NAME, region);
  const endpoint = metadata?.endpoints[ENDPOINT_KEY];

  const instance = useCreateAxiosInstance({ baseURL: endpoint ?? '' });

  return { endpoint, instance };
};

export default useTaskApiInstance;
